export default "__VITE_ASSET__B_UauQ2k__"